import { Box } from '@razorpay/blade/components';
import { routePaths } from 'components/Routes/data';
import { WizardHeader, WizardWrapper } from 'components/WizardViews/components';
import { WizardInfoProvider } from 'components/WizardViews/providers';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { GeneralDetailsStep } from './index';

const CreatePerquisitesForm = () => {
  const currentStep = 1;

  const history = useHistory();

  const handleCloseClick = () => {
    history.push(routePaths.salaryComponents.root);
  };

  return (
    <WizardInfoProvider initialStep={currentStep} totalSteps={1}>
      {/* <WizardPathToStepController routeStepMap={routeToStepMap[bulkUploadType]} /> */}
      <WizardWrapper>
        <WizardHeader
          heading="New"
          subHeading="Perquisite component"
          onCloseClick={handleCloseClick}
        />
        <Box flex={1} overflowY="auto" height="100%">
          <GeneralDetailsStep />
        </Box>
      </WizardWrapper>
    </WizardInfoProvider>
  );
};

export default CreatePerquisitesForm; 